<template lang="pug">
	div.col-md-12.empty-result
		div.text-center
			i.fa.fa-inbox
		div.text-center.message
			| {{message}}
</template>

<script>

export default {
	name: 'emptyResult',
	props: ['message']
};

</script>

<style lang="scss" scoped>

@import "../../styles/variaveis";

.empty-result {

	color: #AAA;

	margin-top: 50px;
	margin-bottom: 50px;

	.fa {
		font-size: 2.6rem;
	}

	&.full-height {
		position: absolute;
		top: 50%;
		margin-top: -40px;
	}

	.message {
		font-size: 0.85rem;
	}
}

</style>



// WEBPACK FOOTER //
// EmptyResult.vue?4044cca2